import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BPD } from '../../../../app.constants';
import { BeneficioPropDiferidoModel } from '../../../shared/models/beneficio-prop-diferido.model';

@Injectable()
export class BeneficioProporcionalDiferidoService {


  constructor(private httpClient: HttpClient) { }

  getConsultarBPD(cdCentrus: number, cdCentrusTit: number): Promise<BeneficioPropDiferidoModel[]> {
    return this.httpClient
      .get<BeneficioPropDiferidoModel[]>(`${BPD}/consultarBPD/${cdCentrus}/${cdCentrusTit}`)
      .toPromise();
  }

  getConsultarPageBPD(cdCentrus: number, cdCentrusTit: number, linesPerPage: number, page: number): Promise<BeneficioPropDiferidoModel[]> {
    return this.httpClient
      .get<BeneficioPropDiferidoModel[]>(`${BPD}/page/consultarBPD/${cdCentrus}/${cdCentrusTit}?linesPerPage=${linesPerPage}&page=${page}`)
      .toPromise();
  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/beneficio-proporcional-diferido/service/beneficio-proporcional-diferido.service.ts